import React from 'react';
import { Col, Row, Container, Button, Card, CardHeader, CardText, CardBody, CardTitle, CardGroup } from 'reactstrap';
import { Link } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';
import { Recipe } from 'src/state/recipe/model';

interface State {
}

interface Props extends RouteComponentProps<any> {
  fetchRecipes(): void,
  recipes: Recipe[]
}

export default class RecipeIndex extends React.Component<Props, State> {
  recipeCard = (recipe: Recipe) => {
    return (
      <Col key={recipe.id} md="4">
        <Card>
          <CardHeader>
            {recipe.name}
          </CardHeader>
          <CardBody>
            <CardTitle>Ingredients:</CardTitle>
            <ol
              style={{
                overflow: 'scroll'
              }}
            >
              {recipe.ingredients && recipe.ingredients.map(ingredient => {
                return <li key={ingredient.id}><CardText>{`${ingredient.quantity} ${ingredient.unit || ''} ${ingredient.name}`}</CardText></li>
              })}
            </ol>
          </CardBody>
          <CardBody>
            <CardTitle>Instructions:</CardTitle>
            <CardText
              style={{
                overflow: 'scroll'
              }}
            >{recipe.instructions}</CardText>
            <Button color="warning" tag={Link} to={`/recipes/${recipe.id}/edit`}>Edit</Button>
            <Button color="info" tag={Link} to={`/recipes/${recipe.id}`}>Show</Button>
          </CardBody>
        </Card>
      </Col>
    )
  }

  componentDidMount() {
    this.props.fetchRecipes();
  }

  render() {
    const { recipes } = this.props;
    return (
      <Container>
        <h1>Recipe Index</h1>
        <CardGroup>
          {recipes.map(recipe => this.recipeCard(recipe))}
        </CardGroup>
        <Button tag={Link} to="/recipes/new">Create Recipe</Button>
        <Button className="pull-right" tag={Link} to="/recipe_picker">Pick This Week's Recipes</Button>
      </Container>
    )
  }
}